module.exports = __webpack_public_path__ + "media/images/salespartner/partner-figure02-81e5a28957dddffd62601c6eac15c857.svg";